<template>
  <div class="elevator" v-show="elevatorvisible">
    <div class="ele_main">
      <div class="back iconfont" @click="handleBack()">&#xe685;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElevaTor',
  data() {
    return {
      elevatorvisible: true,
      clickEle: false
    }
  },
  props: {
    scrollValue: {
      type: Number,
      default: 0
    }
  },
  created() {
  },
  watch: {
    scrollValue: function (newVal) {
      const ele_main = document.querySelector('.ele_main')
      if (newVal > 1400) {
        ele_main.style.opacity = 1
        this.clickEle = true
      } else {
        ele_main.style.opacity = 0
        this.clickEle = false
      }
    }
  },
  methods: {
    handleBack() {
      if (this.clickEle) {
        this.$emit('back')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 35px;
}

@keyframes opacity {
  0% {
    border: 2px solid rgba(150, 150, 150, 0.5);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }

  50% {
    border: 2px solid rgba(150, 150, 150, 0.1);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  100% {
    border: 2px solid rgba(150, 150, 150, 0.5);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }
}

.elevator {
  position: absolute;
  top: 85%;
  left: 93%;
  z-index: 99;
  transition: all 0.5s;

  .ele_main {
    width: 80px;
    height: auto;
    transition: all 0.5s;
    opacity: 0;

    .back {
      width: 80px;
      height: 80px;
      border-radius: 40px;
      rotate: 180deg;
      color: @font_gray;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10px);
      cursor: pointer;
      transition: all 0.5s;
      text-align: center;
      line-height: 80px;
      animation: opacity 3s infinite;

      &:hover {
        transition: all 0.5s;
        font-size: 38px;
      }

    }
  }
}
</style>
